import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIfood = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 38,
	viewBox: "4 5 51 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4 20.0614H7.86093L10.0064 9.6183H6.14496L4 20.0614ZM6.35769 8.37274H10.2348L10.872 5.24822H6.99637L6.35769 8.37274ZM9.36265 23H13.2241L15.5833 11.7173H18.4791L18.9061 9.6183H16.0658L16.1735 9.14609C16.3341 8.25605 16.656 7.25674 18.1037 7.25674C18.9627 7.25674 19.7666 7.30915 20.5705 7.67654L21 5.47271C20.1041 5.16336 19.1614 5.00356 18.2113 5C15.1007 5 12.9563 6.78452 12.1514 9.6183H10.8108L10.3818 11.7173H11.7224L9.36265 23Z",
			fill: "#EA1D2C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.8016 20.6246C26.3676 20.6246 29.5372 16.4317 29.5372 13.0016C29.5372 10.4427 27.2271 9.35351 24.9711 9.35351C19.9738 9.35351 17.2355 13.8753 17.2355 16.9765C17.2355 19.5355 19.5993 20.6246 21.8016 20.6246ZM34.0506 20.6246C38.6167 20.6246 41.7862 16.4317 41.7862 13.0016C41.7862 10.4427 39.4225 9.35351 37.166 9.35351C32.1702 9.35351 29.4309 13.8727 29.4309 16.9765C29.4309 19.5355 31.8483 20.6246 34.0506 20.6246ZM48.0712 20.4066H51.8851L55 5H51.1324L50.2188 9.5736L48.6072 9.41046C44.847 9.41046 41.4091 14.3103 41.4091 17.7953C41.4091 19.2107 42.3202 20.6267 43.8802 20.6267C46.0825 20.6267 47.6405 19.5375 48.2838 18.4484H48.4984L48.0712 20.4066ZM36.1446 28.5195C33.1425 31.0407 29.2866 32.2717 25.4009 31.9496C20.2973 31.6228 16.6443 27.6479 16 23.4555H16.2146C17.3965 26.0719 20.2436 28.5195 23.7356 28.9002C27.2787 29.3358 31.5249 27.7028 33.8345 25.4701L31.2561 23.4555H39.0454L37.3244 31.8408L36.1962 28.5739L36.1446 28.5195Z",
			fill: "#EA1D2C"
		})
	]
});
const ForwardRef = forwardRef(SvgIfood);
export { ForwardRef as ReactComponent };
